import { RerunReasonType } from "./enums";

export class RerunTestRequest {
    OrderId: number;
    OriginalSpecimenNo: number;
    SpecimenTransactionIds: number[];
    Reason: RerunReasonType;
    OtherReasonText: string;
    Notes: string;
    NewCollectionDate: Date;
    PreviousSpecimenId?: number;
}